import { Fragment, ReactElement } from 'react';
import ResearchNotificationsCivilStatusRegistryOfficeShared from 'shell/components/shared/research-notifications-civil-status-registry-office/list';

const ResearchNotificationsCivilStatusRegistryOfficePage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchNotificationsCivilStatusRegistryOfficeShared />
    </Fragment>
  );
};

ResearchNotificationsCivilStatusRegistryOfficePage.displayName =
  'Research Notifications Civil Status Registry Office Page Mutation component';

export default ResearchNotificationsCivilStatusRegistryOfficePage;
